import { Route, redirect, Outlet } from 'react-router-dom';
import { type RouteRegistryEntry } from 'FrontRoyalRouteRegistry/FrontRoyalRouteRegistry.types';
import { type FrontRoyalRootScope } from 'FrontRoyalAngular';
import { getProgramInclusion } from 'Users';
import { angularInjectorProvider } from 'Injector';
import { ProtectedRoute } from 'ProtectedRoute';

const BASE = '/resources';

export const RESOURCES_ROUTES = {
    RESOURCES: {
        path: BASE,
        ADMISSIONS: { path: `${BASE}/admissions`, relativePath: 'admissions' },
        ACADEMIC_AND_PROGRAM_SUPPORT: {
            path: `${BASE}/academic-and-program-support`,
            relativePath: 'academic-and-program-support',
        },
        CAREER_SERVICES: { path: `${BASE}/career-services`, relativePath: 'career-services' },
        LIBRARY_SERVICES: { path: `${BASE}/library-services`, relativePath: 'library-services' },
        STUDENT_EVENTS: { path: `${BASE}/student-events`, relativePath: 'student-events' },
        SEARCH: { path: `${BASE}/search`, relativePath: 'search' },
    },
};

export function configureResourcesRoutes(): RouteRegistryEntry[] {
    return [
        {
            routes: RESOURCES_ROUTES,
            config: {},
        },
    ];
}

async function getLazyResourcesComponent(
    component:
        | 'Layout'
        | 'Admissions'
        | 'AcademicAndProgramSupport'
        | 'CareerServices'
        | 'LibraryServices'
        | 'StudentEvents'
        | 'SearchResults',
) {
    const components = await import(/* webpackPrefetch: true */ './Resources');
    const ResourcesComponent = components[component];
    if (component === 'Layout') {
        return {
            Component: () => (
                <ProtectedRoute accessPolicy="hasLearnerAccess">
                    <ResourcesComponent />
                </ProtectedRoute>
            ),
        };
    }
    return { Component: ResourcesComponent };
}

export function getResourcesRoutes() {
    return (
        <Route id="resources-routes" element={<Outlet />}>
            <Route path={RESOURCES_ROUTES.RESOURCES.path} lazy={() => getLazyResourcesComponent('Layout')}>
                <Route
                    index
                    loader={() => {
                        const { currentUser = null } = angularInjectorProvider.get<FrontRoyalRootScope>('$rootScope');
                        const programInclusion = getProgramInclusion(currentUser);
                        const showAdmissionsTab = !programInclusion;
                        return redirect(
                            showAdmissionsTab
                                ? RESOURCES_ROUTES.RESOURCES.ADMISSIONS.path
                                : RESOURCES_ROUTES.RESOURCES.ACADEMIC_AND_PROGRAM_SUPPORT.path,
                        );
                    }}
                />
                <Route
                    path={RESOURCES_ROUTES.RESOURCES.ADMISSIONS.relativePath}
                    lazy={() => getLazyResourcesComponent('Admissions')}
                />
                <Route
                    path={RESOURCES_ROUTES.RESOURCES.ACADEMIC_AND_PROGRAM_SUPPORT.relativePath}
                    lazy={() => getLazyResourcesComponent('AcademicAndProgramSupport')}
                />
                <Route
                    path={RESOURCES_ROUTES.RESOURCES.CAREER_SERVICES.relativePath}
                    lazy={() => getLazyResourcesComponent('CareerServices')}
                />
                <Route
                    path={RESOURCES_ROUTES.RESOURCES.LIBRARY_SERVICES.relativePath}
                    lazy={() => getLazyResourcesComponent('LibraryServices')}
                />
                <Route
                    path={RESOURCES_ROUTES.RESOURCES.STUDENT_EVENTS.relativePath}
                    lazy={() => getLazyResourcesComponent('StudentEvents')}
                />
                <Route
                    path={RESOURCES_ROUTES.RESOURCES.SEARCH.relativePath}
                    lazy={() => getLazyResourcesComponent('SearchResults')}
                />
            </Route>
        </Route>
    );
}
